import SubHeading from './SubHeading/SubHeading';
import Navbar from './Navbar/Navbar';

export {
  SubHeading,
  Navbar,
};

var docWidth = document.documentElement.offsetWidth;
[].forEach.call(
  document.querySelectorAll('*'),
  function(el) {
    if (el.offsetWidth > docWidth) {
      console.log(el);
    }
  }
);